<div id="tab-elimination" class="w-100 d-flex flex-column flex-grow-1">
    <div class="d-flex flex-row m-2">
        <button id="btn-elimination-import" class="btn btn-primary">Import from ranking...</button>
        <span class="fs-4 flex-grow-1 fw-bold text-end invisible" id="span-remaining"><span id="num-current">9</span> / <span id="num-total">20</span></span>
    </div>
    <div class="games row row-cols-1 row-cols-lg-2 row-cols-xxl-3 g-3">
    </div>
</div>